// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-1-top{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
}
.Image-box-Edituser{
    margin: 12px;
    width: 20%;
    border: 1px solid #c4c4c4;
    border-radius: 10px;
    padding: 10px;
}

.submit-btn-edituser{
    background: blue !important;
    color: #fff !important;
    margin-left: 10px !important;
    margin-top: 10px !important;

}

.image-container{
    max-width: 175px;
    height: 100px;
    width: 100%;
    margin-top: 10px;
    border-radius: 5px;
}

.date-box{
    width: 192px;
}

.image-box-2{
    margin: 12px;
    max-width: 200px;
    border: 1px solid #cacacb;
    border-radius: 7px;
    padding: 10px;

}
.image-inside{
    max-width: 175px;
}
.image-section-box{
    margin: 12px;
    width: 20%;
    border: 1px solid #c4c4c4;
    border-radius: 7px;
    padding: 7px;
}


.button-box{
    background: blue !important;
    color: #fff !important;
    margin-left: 10px !important;
    margin-top: 10px !important;
}

.hide-section-box{
    margin: 9px;
    width: 20%;
    border: 1px solid #c4c4c4;
    padding: 10px;
    border-radius: 8px;
    height: 53px;
    position: relative;
}

.floating-title{
    position: absolute;
    top: -11px;
    background: #fff;
    padding: 0 5px;

}

.checkbox-box{
    position: absolute;
    top: 12px;
}


.image-input-class-2222[type="file"] {
    height: auto;
    overflow: hidden;
    width: 40%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    opacity: 0;
}

.image-input-class-22[type="file"]+.attach-icon {
  background: #fff;
  color: #000;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Rubik', sans-serif;
  font-size: inherit;
  font-weight: 500;
  outline: none;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;
  width: 239px;
  text-align: left;
  height: 50px;
  display: flex !important;
  align-items: center;
  gap: 2px;
  padding-left: 0;
}
.textarea-new{
    min-height: 50px;
    max-height: 200px;
    overflow-y: scroll;
    resize: none;
    width: 85%;
    display: block;
    height: 66px !important;
    padding: 6px 7px;
    border-radius: 6px;
    border: 1px solid #c4c4c4;
}
.hide-btn-2{
    background: Blue !important;
    color: #fff;
    padding: 10px;
    border-radius: 10px;
    width: 20%;
    text-align: center;
    margin-bottom: 10px;
    margin-left: 10px;
    margin-top: 35px;
}

.enter-password-area{
    width: 20%;
    margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/content/applications/Users/EditUser/EditUser.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;;AAE/B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;;AAEjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;;AAGA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB","sourcesContent":[".box-1-top{\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 20px;\n}\n.Image-box-Edituser{\n    margin: 12px;\n    width: 20%;\n    border: 1px solid #c4c4c4;\n    border-radius: 10px;\n    padding: 10px;\n}\n\n.submit-btn-edituser{\n    background: blue !important;\n    color: #fff !important;\n    margin-left: 10px !important;\n    margin-top: 10px !important;\n\n}\n\n.image-container{\n    max-width: 175px;\n    height: 100px;\n    width: 100%;\n    margin-top: 10px;\n    border-radius: 5px;\n}\n\n.date-box{\n    width: 192px;\n}\n\n.image-box-2{\n    margin: 12px;\n    max-width: 200px;\n    border: 1px solid #cacacb;\n    border-radius: 7px;\n    padding: 10px;\n\n}\n.image-inside{\n    max-width: 175px;\n}\n.image-section-box{\n    margin: 12px;\n    width: 20%;\n    border: 1px solid #c4c4c4;\n    border-radius: 7px;\n    padding: 7px;\n}\n\n\n.button-box{\n    background: blue !important;\n    color: #fff !important;\n    margin-left: 10px !important;\n    margin-top: 10px !important;\n}\n\n.hide-section-box{\n    margin: 9px;\n    width: 20%;\n    border: 1px solid #c4c4c4;\n    padding: 10px;\n    border-radius: 8px;\n    height: 53px;\n    position: relative;\n}\n\n.floating-title{\n    position: absolute;\n    top: -11px;\n    background: #fff;\n    padding: 0 5px;\n\n}\n\n.checkbox-box{\n    position: absolute;\n    top: 12px;\n}\n\n\n.image-input-class-2222[type=\"file\"] {\n    height: auto;\n    overflow: hidden;\n    width: 40%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    opacity: 0;\n}\n\n.image-input-class-22[type=\"file\"]+.attach-icon {\n  background: #fff;\n  color: #000;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: 'Rubik', sans-serif;\n  font-size: inherit;\n  font-weight: 500;\n  outline: none;\n  position: relative;\n  transition: all 0.3s;\n  vertical-align: middle;\n  width: 239px;\n  text-align: left;\n  height: 50px;\n  display: flex !important;\n  align-items: center;\n  gap: 2px;\n  padding-left: 0;\n}\n.textarea-new{\n    min-height: 50px;\n    max-height: 200px;\n    overflow-y: scroll;\n    resize: none;\n    width: 85%;\n    display: block;\n    height: 66px !important;\n    padding: 6px 7px;\n    border-radius: 6px;\n    border: 1px solid #c4c4c4;\n}\n.hide-btn-2{\n    background: Blue !important;\n    color: #fff;\n    padding: 10px;\n    border-radius: 10px;\n    width: 20%;\n    text-align: center;\n    margin-bottom: 10px;\n    margin-left: 10px;\n    margin-top: 35px;\n}\n\n.enter-password-area{\n    width: 20%;\n    margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
